import axios from "axios";
import {accountUtils, userUtils} from "../utils";

export const joinAccount = (user, success, failure) => {
    // need to skip the request interceptors (don't want to redirect to login on 401)
    const instance = axios.create();
    const url = "/api/v1/account/join";

    instance.post(url, {
        user: {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            phone: user.phone,
            password: user.password,
        },
    })
    .then(response => {
        const json = response.data;

        accountUtils.sanitizeAccount(json.account);
        userUtils.sanitizeUser(json.user);

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const loadMyAccount = function(success, failure) {
    success({});
};

export const saveMyAccount = function(account, success, failure) {
    success({});
};

export const uploadImage = function(accountId, logo, success, failure) {
    success(null);
};
